import { render, staticRenderFns } from "./EditPackingList.vue?vue&type=template&id=6f456d1b"
import script from "./EditPackingList.vue?vue&type=script&lang=js"
export * from "./EditPackingList.vue?vue&type=script&lang=js"
import style0 from "./EditPackingList.vue?vue&type=style&index=0&id=6f456d1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports